import React, { useState, useEffect } from "react";
import DataTable from "../../Common/DataTable/DataTable";
import Button from "../../Common/Button";
import { fetchOrders, getStacksList } from "../../api";
import NewStackBuy from "./NewStackBuy";
import "bootstrap/dist/css/bootstrap.min.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import styles from "./buyStack.module.css";
import CustomSpinner from "../../Common/Spinner";


const columns = [
  {
    Header: "Ticker",
    accessor: "symbol",
  },
  {
    Header: "Amount",
    accessor: "amountCash",
  },
  {
    Header: "Status",
    accessor: "status",
  },
  {
    Header: "Comment",
    accessor: "comment",
  },
  {
    Header: "Date Time",
    accessor: "createdAt",
  },
];

const BuyStack = ({ custId ,userData, featureAccess}) => {
  const [showModal, setShowModal] = useState(false);
  const [orders, setOrders] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [buttonError, setButtonError] = useState("");
  const [UpdateList, setUpdateList] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);

  const isButtonDisabled = orders.some(
    (order) => order.status.toLowerCase() === "pending"
  );

  const handleShowModal = () => {
    if (isButtonDisabled) {
      setButtonError(
        "Your existing order is still pending, so you cannot add a new one."
      );
    } else if(buttonDisabled) {
      setButtonError(errorMessage);
    } else {
      setShowModal(true);
      setButtonError("");
    }
  };


  const getOrders = async () => {
    setDataLoading(true);
    try {
      const response = await fetchOrders(custId);
      setDataLoading(false);
      setOrders(response?.data || []);
    } catch (error) {
      setDataLoading(false);
      setButtonError("Failed to fetch Orders data.");
    }
  };
  
  useEffect(() => {
    const stacksList = async () => {
      setDataLoading(true);
      try {
        const response = await getStacksList(custId);
        if(response.code !== 200){
          setButtonDisabled(true);
          setDataLoading(false);
          setErrorMessage(response?.data?.message || "Something went wrong!")
        } else{
          setDataLoading(false);
          setErrorMessage("");
        }
      }  catch (error) {
        setButtonError(error?.message || "Something went wrong!");
      }
    };
    stacksList();
  }, []);

  useEffect(() => {
    if (custId) {
      getOrders();
    }
  }, [custId, UpdateList]);


  return (
    <div className={styles.container} style={{ position: "relative" }}>
      {userData?.accountStatus === "APPROVED" && (
        <div
          style={{
            marginTop: "5px",
            marginBottom: "15px",
            width: "100%",
            display: "flex",
            justifyContent: "start",
             width: "160px"
          }}
        >
          {featureAccess?.writeAccess && (
          <Button
            onClick={handleShowModal}
            // disabled={isButtonDisabled || buttonDisabled}
            title={"Add Stack"}
          />
          )}
        </div>
      )}
      {buttonError && (
        <div style={{ color: "red", marginBottom: "10px" }}>{buttonError}</div>
      )}
      {/* {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>} */}
      {dataLoading ? (
        <CustomSpinner />
      ) : (
        <>
          {Array.isArray(orders) && orders.length > 0 ? (
            <DataTable columns={columns} list={orders} />
          ) : (
            <p
              style={{ color: "white", marginTop: "80px", textAlign: "center" }}
            >
              No Data Found
            </p>
          )}
        </>
      )}
      <Offcanvas
        show={custId !== null && showModal}
        onHide={() => setShowModal(false)}
        placement="end"
        className={styles.offcanvas}
        backdropClassName={styles.backgroundBlur}
        style={{ color: "white", backgroundColor: "#28282B", width: "500px" }}
      >
        <Offcanvas.Header
          closeButton
          style={{
            backgroundColor: "#343434",
            color: "white",
            fontSize: "20px",
            height: "50px",
          }}
        >
          <Offcanvas.Title
            style={{ color: "white", width: "100%", margin: "20px 20px" }}
          >
            Buy Stack
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <NewStackBuy
            custId={custId}
            newStackAdded={() => setUpdateList((prev) => !prev)}
            setShowModal={setShowModal}
          />
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default BuyStack;
